
























import { Component, Watch, Prop, Emit } from 'vue-property-decorator';
import Vue from 'vue';

@Component
export default class MenuDropdown extends Vue {
  @Prop({ default: false }) 
  open: boolean;

  @Prop({ default: 0 }) 
  top: number;

  @Prop({ default: () => [] as any[] }) 
  items: any[];

  @Prop({ default: '' }) 
  dropdownClass: string;

  @Emit('click-outside')
  onClickOutside() {}

  scrollPosition: number = document.body.scrollTop;
  scrollWidth: number = 0;
  maxHeight: number = this.getMaxHeight();

  lastSource: string = 'body'; 

  getMaxHeight() {
    const windowHeight = document.documentElement.clientHeight;
    return windowHeight - this.pTop;
  }

  get computedScrollPosition() {
    return this.top - this.scrollPosition + 1;
  }

  get pTop() {
    return this.top;
  }

  @Watch('open')
  onOpenChanged(value: boolean) {
    if(value) {
      this.updateScrollPosition();
      this.maxHeight = this.getMaxHeight();
    }
  }

  @Watch('top')
  onStoreStateMobileMenuGroupingOpenChanged(value: boolean) {
    if(value) {
      this.scrollWidth = document.body.offsetWidth - document.body.clientWidth;
      this.updateScrollPosition();
    }
  }

  mounted() {
    this.bus.on('body-scrolled', this.onBusBodyScrolled);
    this.bus.on('window-resized', this.onBusWindowResized);
  }

  beforeDestroy() {
    this.bus.off('body-scrolled', this.onBusBodyScrolled);
    this.bus.off('window-resized', this.onBusWindowResized);
  }

  updateScrollPosition(source: string = this.lastSource) {
    if(source === 'body') {
      this.scrollPosition = document.body.scrollTop;
    } else if(source === 'window') {
      this.scrollPosition = document.documentElement.scrollTop;
    }

    this.lastSource = source;
  }

  onBusBodyScrolled(source: string) {
    if(this.open) {
      this.updateScrollPosition(source);
    }
  }

  onBusWindowResized() {
    this.maxHeight = this.getMaxHeight();
  }
}
